import { MOKA_INVENTORY_API } from 'api/constants';

export const LIBRARIES_EXPORT = `${MOKA_INVENTORY_API}/v1/ingredients/export`;
export const LIBRARY_DOWNLOAD_TEMPLATE = `${MOKA_INVENTORY_API}/v1/ingredients/export_template`;
export const LIST_LIBRARY_URL = `${MOKA_INVENTORY_API}/v1/ingredients`;
export const INGREDIENT_WITH_UNCATEGORY = `${MOKA_INVENTORY_API}/v1/ingredient-categories/with_uncategorized`;
export const LIBRARY_SUMMARY_URL = `${MOKA_INVENTORY_API}/v1/ingredients`;
export const LIBRARY_BY_ID = id => `${LIST_LIBRARY_URL}/${id}`;
export const CREATE_LIBRARY = `${MOKA_INVENTORY_API}/v1/ingredients`;
export const CREATE_ALL_OUTLET_LIBRARY = `${MOKA_INVENTORY_API}/v1/ingredients/create_all_outlet`;
export const UPDATE_LIBRARY_BY_ID = id => `${LIBRARY_BY_ID(id)}/update_image`;
export const DELETE_LIBRARY_BY_ID_V1 = id => `${LIBRARY_BY_ID(id)}`;
export const LIBRARY_GET_UNITS = `${MOKA_INVENTORY_API}/v1/units`;
export const INGREDIENT_CREATE_CATEGORY = `${MOKA_INVENTORY_API}/v1/ingredient-categories`;
export const V1_IMPORT_LIBRARY_TEMPORARY = `${MOKA_INVENTORY_API}/v1/ingredients/import_temp`;
export const V1_IMPORT_LIBRARY = `${MOKA_INVENTORY_API}/v1/ingredients/import`;
export const V1_IMPORT_LIBRARY_TEMPLATE = `${MOKA_INVENTORY_API}/v1/ingredients/export_template`;
